import React, { useState } from "react";
// import { Button, Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import styles from "./WatchlistOpenTabModalStyles.css";
import { addToWatchlistOpen, fetchUsers } from "../../../API/api";
import { handleError } from "../../../utils";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { Button, Modal, Box, Typography, Grid, } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { ModalHeader } from "../../../Constants";
import {CloseButton} from "react-bootstrap";


export default function WatchlistOpenTabModal() {
    const dispatch = useDispatch();
    const { advanceFilterModalToggle, openQuestionsData, openQuestionsDelete, getQuestionText, updateOpenTabData, openQuestionsDataLoading } = bindActionCreators(Actions, dispatch);
    const modalState = useSelector(state => state.domain);
    const openState = useSelector(state => state.openQuestions);
    const searchState = useSelector(state => state.search);
    const [selected, setSelected] = useState(searchState.selectedQuestion.watchlist.filter(wtch => {
        wtch.userUuid = wtch.userUuidStr;
        return wtch;
    }));
    const [inputval, setInputVal] = useState("");
    const [fetchUser, setFetchUser] = useState([]);
    const [searchedUser, setSearchUsers] = useState([]);
    const onSuccessfulWatchListAdd = () => {
        return (
            <>
                {/* <p style={{ fontSize: "13px", fontWeight: "bold" }}>Success!</p> */}
                <span style={{ fontSize: "12px" }}>
                    Users were added to Watchlist successfully..
                </span>
            </>
        )
    }

    const isUserUuidStrExist = (data) => {
        let newArr = data.filter(obj => {
            if (obj.userUuidStr === undefined) {
                obj.userUuidStr = obj.userUuid;
            }
            return obj;
        })
        return newArr;
    }
    const addToWatchList = () => {
        let payload = {
            questionUuidStr: searchState.selectedQuestion.questionUuid,
            watchlist:
                selected.length > 0 ? selected.map((user) => user.userUuid) : selected,
        }

        addToWatchlistOpen(payload).then((res) => {
            if (res === undefined) return;
            if (res.data.data !== undefined || res.data.success) {
                let filteredData = openState.openData.filter((ques) => {
                    if (ques.questionUuid === searchState.selectedQuestion.questionUuid) {
                        ques.watchlist = isUserUuidStrExist(selected);
                    }
                    return ques;
                })
                openQuestionsData(filteredData);
                // updateOpenTabData();
                advanceFilterModalToggle({ bool: false, value: "" })
                toast.success(onSuccessfulWatchListAdd(), {
                    position: toast.POSITION.TOP_RIGHT,
                });

            };
        }).catch((err) => handleError(err));
    }

    const getUsers = (e) => {
        setInputVal(e.target.value);
        if (e.target.value.length > 3) {
            fetchUsers(e.target.value, true)
                .then((res) => {
                    if (res === undefined) return;
                    let filtered = res.data.data.users.filter(function (obj) {
                        let found = false;
                        selected.filter((obj2) => {
                            if (obj2.userUuid === obj.userUuid) {
                                found = true;
                            }
                        });
                        if (found === false) {
                            return obj;
                        }
                    });
                    setFetchUser(filtered);
                })
                .catch((err) => { });
        } else {
            setFetchUser([])
        }
    };

    const onClickUsers = (val) => {
        setSelected([...selected, val]);
        setFetchUser([]);
        setInputVal("");
    };

    const onClickRemoveUsers = (val) => {
        let filteredData = selected.filter((obj) => {
            if (obj.userUuid !== val) {
                return obj;
            }
        });
        setSelected(filteredData);
    };

    const buttonStyles = {
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 400,
        boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
        color: 'rgb(255, 255, 255)',
        border: '1px solid rgb(255, 255, 255)',
        height: '40px',
        minWidth: '88px',
        background: 'linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)',
        marginBottom: '14px',
        cursor: 'pointer',
        textTransform: 'capitalize'
    }

    const buttonStylesCancel = {
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 400,
        boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
        color: 'black',
        border: '1px solid rgb(224, 226, 230)',
        height: '40px',
        minWidth: '88px',
        background: '#f6f7f8',
        marginBottom: '14px',
        textTransform: 'capitalize'
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        bgcolor: 'background.paper',
        boxShadow: 24,
        padding: '16px 16px 0 16px',
        fontFamily: 'Inter',
        fontWeight: 300,
        borderRadius:'6px'
    };

    return (
        <Modal
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            open={modalState.modalState} onClose={() => advanceFilterModalToggle({ bool: false, value: "" })} >
            {/* <ModalHeader style={{color:'#212259',fontSize:'20px'}} closeButton><i className="fa fa-users" style={{marginRight:'5px',}} />Watchlist Users</ModalHeader> */}
            {/* <ModalBody className="modalBody" style={{paddingBottom:0}}> */}
            <Box sx={style}>
                <Grid container justifyContent="space-between">
                    <Box>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={ModalHeader.styles}>
                            Watchlist Users
                        </Typography>
                    </Box>
                    <Typography sx={{ display: "flex", alignItems: "center" }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })} >
                    <CloseButton style={{padding:'8px'}} />                     
                    </Typography>
                </Grid>
                <div className="mb-1 mt-3">
                    <div className="form-control">
                        {selected.length > 0 && (
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                {selected.map((obj) => {
                                    return (
                                        <p className="selectedUserASG">
                                            {obj.firstName} {obj.lastName} {`<${obj.email}>`}{" "}
                                            <span
                                                className="crossbuttonASK"
                                                onClick={() => onClickRemoveUsers(obj.userUuid)}
                                            >
                                                x
                                            </span>
                                        </p>
                                    );
                                })}
                            </div>
                        )}
                        <Form.Control
                            as="input"
                            value={inputval}
                            rows={3}
                            placeholder="Enter name or email address"
                            autoComplete="off"
                            style={{ border: "none", fontSize: "13px" }}
                            onChange={(e) => getUsers(e)}
                        />
                    </div>
                    {fetchUser.length > 0 && (
                        <div
                            className="watchListUserslist"
                            style={{
                                width: "95%",
                                position: "absolute",
                                zIndex: "1000",
                                background: "#FFF",
                            }}
                        >
                            {fetchUser.map((user) => {
                                return (
                                    <div
                                        style={{
                                            padding: "7px",
                                            border: "lightgrey solid 1px",
                                            borderRadius: "5px",
                                            fontSize: "12px",
                                        }}
                                    >
                                        <span value={user} onClick={() => onClickUsers(user)}>
                                            {user.firstName} {user.lastName} {`<${user.email}>`}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
                <div className="row" style={{ marginTop: "20px", marginBottom: "12px" }}>
                    <div className="col-lg-12 d-flex justify-content-center" style={{ gap: '12px', textTransform: 'capitalize' }}>
                        <Button style={buttonStylesCancel} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>Cancel</Button>
                        <Button style={buttonStyles} onClick={() => addToWatchList()} >Update</Button>
                    </div>
                </div>
            </Box>
            {/* </ModalBody> */}
        </Modal>
    )
}